// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 13 hooks for backend/inbox.

import { useBackend } from '../useBackend'

/** POST /api/inbox/addNote */
export function useAddNote<T = any>() {
  return useBackend<T>('inbox/addNote')
}

/** POST /api/inbox/assignTicket */
export function useAssignTicket<T = any>() {
  return useBackend<T>('inbox/assignTicket')
}

/** POST /api/inbox/bulkSetStatus */
export function useBulkSetStatus<T = any>() {
  return useBackend<T>('inbox/bulkSetStatus')
}

/** POST /api/inbox/getAccess */
export function useGetAccess<T = any>() {
  return useBackend<T>('inbox/getAccess')
}

/** POST /api/inbox/getAttachmentUrl */
export function useGetAttachmentUrl<T = any>() {
  return useBackend<T>('inbox/getAttachmentUrl')
}

/** POST /api/inbox/getKpi */
export function useGetKpi<T = any>() {
  return useBackend<T>('inbox/getKpi')
}

/** POST /api/inbox/getOptions */
export function useGetOptions<T = any>() {
  return useBackend<T>('inbox/getOptions')
}

/** POST /api/inbox/getQueue */
export function useGetQueue<T = any>() {
  return useBackend<T>('inbox/getQueue')
}

/** POST /api/inbox/getTicket */
export function useGetTicket<T = any>() {
  return useBackend<T>('inbox/getTicket')
}

/** POST /api/inbox/sendReply */
export function useSendReply<T = any>() {
  return useBackend<T>('inbox/sendReply')
}

/** POST /api/inbox/setCategory */
export function useSetCategory<T = any>() {
  return useBackend<T>('inbox/setCategory')
}

/** POST /api/inbox/setFiltered */
export function useSetFiltered<T = any>() {
  return useBackend<T>('inbox/setFiltered')
}

/** POST /api/inbox/setStatus */
export function useSetStatus<T = any>() {
  return useBackend<T>('inbox/setStatus')
}
